<template>
    <div class="channels-details">
        <ns-loader
            ref="ns-loader"
            :to-load="toLoad"
            @dataFetched="onDataFetched"
        >
            <loading-template slot="loader"></loading-template>

            <el-tabs
                slot="content"
                class="gcmcn-tabs"
                style="margin-top: 30px;"
                v-model="activeName"
            >
                <el-tab-pane label="Rights" name="rights">
                    <channels-rights
                        ref="rightsView"
                        :channel="channel"
                        :broadcast-right="broadcastRight"
                        :filtered-blanking-profile="filteredBlankingProfile"
                        :channel-configurations="configurations"
                        @on-update-broadcast-right="sendEmit"
                    ></channels-rights>
                </el-tab-pane>
                <el-tab-pane
                    v-if="isBlankable"
                    label="Profiles"
                    name="profiles">
                    <profiles
                        ref="profilesView"
                        :channel="channel"
                        :blanking-profiles="blankingProfiles"
                        :broadcast-rights="filteredBroadcastRights"
                        @update-data-list="updateDataList"
                    ></profiles>
                </el-tab-pane>
                <el-tab-pane
                    label="Blanking export"
                    name="blankingExport"
                    v-if="isBlankable">
                    <blanking-export
                        :channel="channel"
                        :filtered-broadcast-rights="filteredBroadcastRights"
                    ></blanking-export>
                </el-tab-pane>
                <el-tab-pane label="Details" name="details">
                    <channels-details
                        :channel="channel"
                        :universe="universe"
                        :event="event"
                        :min-duration-parameter="minDurationParameter"
                        :channel-modification-request="channelModificationRequest"
                        :broadcast-right="broadcastRight"
                        @on-trigger-refresh="onTriggerRefresh"
                        @on-update-channel="onUpdateChannel"
                        @on-channel-stopped="onChannelStopped"
                        @un-select-channel="unSelectChannel"
                    ></channels-details>
                </el-tab-pane>
                <el-tab-pane label="Configuration" name="configuration">
                    <configuration-view
                        ref="confirgurationView"
                        :channel-configurations="configurations"
                        :broadcast-right="broadcastRight"
                        :channel="channel"
                        :selected-taker="selectedTaker"
                        @on-configuration-created="onConfigurationCreated"
                        @on-configuration-cancelled="onConfigurationCreated"
                        @trigger-refresh="updateDataList"
                        :event="event"
                    ></configuration-view>
                </el-tab-pane>
                <el-tab-pane label="Scheduling" name="scheduling">
                    <schedulings-view
                        ref="schedulingsView"
                        :schedulings="schedulings"
                        :channel="channel"
                        :min-duration-parameter="minDurationParameter"
                        @update-data-list="updateDataList"
                    ></schedulings-view>
                </el-tab-pane>
            </el-tabs>
        </ns-loader>
    </div>
</template>

<script>
import ChannelsRights from './channels-rights.vue';
import ChannelsDetails from './channels-details.vue';
import SchedulingsView from './SchedulingsView';
import ConfigurationView from './configuration-view.vue';
import Profiles from './Profiles';
import BlankingExport from './BlankingExport';

import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import LoadingTemplate from '../../partials/ns-loader-template.vue';

export default {

    name: 'channel-details-tabs',
    props:{
        channel: {
            type: Object,
            required: true,
        },
        broadcastRight: {
            type: Array,
            required: true,
        },
        events: {
            type: Array,
            required: true,
        },
        minDurationParameter:{
            type: Number,
            required: true,
        },
        schedulings:{
            type: Array,
            reqiured: true
        },
    },
    components:{
        ChannelsRights,
        ChannelsDetails,
        ConfigurationView,
        NsLoader,
        LoadingTemplate,
        SchedulingsView,
        Profiles,
        BlankingExport,
    },
    data () {
        return {
            activeName: 'rights',
            configurations: {},
            blankingProfiles: [],
            universe: null,
            channelModificationRequest: null,
            selectedTaker: ''
        };
    },
    computed:{
        toLoad () {
            return [
                {
                    name: 'configurations',
                    model: 'configurations',
                    filters: {
                        channel: this.channel.uid,
                        cancelled: false,
                    }
                },
                {
                    name: 'channelModificationRequests',
                    model: 'channelModificationRequests',
                    filters: {
                        channel: this.channel.uid,
                        status__in: 'PENDING,RUNNING',
                    }
                },
                {
                    name: 'blankingProfiles',
                    model: 'blankingProfiles',
                    filters: {
                        channel: this.channel.uid,
                        archived: false,
                        c_resp_nested: true,
                    }
                },
                {
                    name: 'universe',
                    model: 'universes',
                    uid: this.event.universe_uid,
                },
            ];
        },
        event(){
            return this.events.find(event => event.uid === this.channel.event_uid);
        },
        isBlankable(){
            if(this.channel.is_blankable){
                return true;
            }
            return false;
        },
        filteredBroadcastRights(){
            let filteredBroadcastRights = this.broadcastRight.filter(broadcastRight => broadcastRight.channel_uid === this.channel.uid);
            return filteredBroadcastRights;
        },
        filteredBlankingProfile(){
            let filteredBlankingProfile = this.blankingProfiles.filter(blankingProfile => blankingProfile.channel_uid === this.channel.uid);
            return filteredBlankingProfile;
        }
    },
    watch:{
        /* 
            We cant set schedulings and configuration view's height in 
            their mounted hook or after data are fetched since all tabs are loaded 
            when the default tab is mounted == it'll use the default (rights) tab's height 
            and set a wrong height for schedulings view.
            So we call setViewHeight() methods when changing tabs
            ***this watch should be used to set each tabs height.***
        */
        activeName: function (newVal){
            if(newVal === 'configuration'){
                if(this.$refs.confirgurationView){
                    this.$refs.confirgurationView.setViewHeight();
                }else{
                    return
                }
            }else if(newVal === 'profiles'){
                this.$refs.profilesView.setViewHeight();
            }else if(newVal === 'scheduling'){
                this.$refs.schedulingsView.setViewHeight();
            }
        }
    },
    mounted(){
        if(this.$route.params && this.$route.params.tab){
            this.activeName =  this.$route.params.tab;
            delete this.$route.params.tab;
        }
        if(this.$route.params && this.$route.params.takerUid){
            this.selectedTaker = this.$route.params.takerUid;
            delete this.$route.params.takerUid;
        }
    },
    methods:{
        sendEmit() {
            this.$emit('on-update-broadcast-right');
        },
        onConfigurationCreated (){
            this.$refs['ns-loader'].triggerRefresh();
        },
        onDataFetched (res){
            this.$set(this, 'blankingProfiles', res.blankingProfiles);
            this.$set(this, 'channelModificationRequest', res.channelModificationRequests[0]);
            this.$set(this, 'configurations', res.configurations);
            this.$set(this, 'universe', res.universe);
        },
        onTriggerRefresh (){
            this.$emit('on-trigger-refresh');
        },
        onUpdateChannel(){
            this.$emit('on-update-channel');
        },
        updateDataList(){
            this.$refs['ns-loader'].triggerRefresh();
        },
        onChannelStopped(){
            this.$refs['ns-loader'].triggerRefresh();
            this.$emit('on-channel-stopped');
        },
        unSelectChannel(){
            this.$emit('un-select-channel');
        }
    }
};
</script>

<style lang="css" scoped>

.gcmcn-danger-btn{
    margin-right: 10px;
    margin-bottom: 10px;
}

.padding-left{
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/channels-details-tabs.vue